<div class="accordion rounded-pill" [ngClass]="maximized? 'FullScren': ''">
  <div class=" accordion-item rounded-corner shadow-b">
    <h2 class="accordion-header accordion-button text-primary  p-2 box-shadow-0">

      <i class="fal fa-file-alt icon-header"></i>
      <b class="font-md">{{eventCountLabel}}</b>
      <button type="button" class="btn">
        <i class="zoom-in" aria-hidden="true" (click)=toggleMaximize() title="{{minimizeLabel}}"
          data-bs-toggle="tooltip" data-bs-placement="top" [ngClass]="maximized? 'fal fa-compress-wide': '' "></i>
        <i class="zoom-in" aria-hidden="true" (click)=toggleMaximize() title="{{maximizeLabel}}"
          data-bs-toggle="tooltip" data-bs-placement="top" [ngClass]="maximized? '': 'fal fa-expand' "></i>
      </button>
    </h2>
    <button
      class="accordion-button text-primary p-2 h-30 accordion-icon  box-shadow-0 position-absolute top-0 right-10 rounded-corner"
      type="button" [ngClass]="collapsed? 'collapsed' : '' " (click)="toggleCollapse()">
    </button>
    <div class="accordion-collapse collapse custom-area" [ngClass]="collapsed? 'hide': 
    maximized? 'show h-140' :
    appConfig.defaults.EnableAgentTime? 'show h-140': 'show h-full'" aria-labelledby="panelsStayOpen-headingOne">
      <div class="accordion-body text-center bg-primary-light pt-1">
        <div *ngIf="violationsKeys.length < 1">
          <img src="assets/images/no-data.svg" height="100px" width="100px" alt="..."
            class="img-thumbnail border-0 col-md-3">
          <h6>{{noDataFoundLabel}}</h6>
        </div>
        <ng-container *ngIf="violationsKeys.length">
          <table class="table table-hover text-truncate font-sm m-0 font-primary-color lh-1 boxed-table">
            <thead>
              <tr>
                <th scope="col">{{slNoLabel}}</th>
                <th scope="col">{{eventLabel}}</th>
                <th scope="col">{{countLabel}}</th>
                <th scope="col">{{actionLabel}}</th>
              </tr>
            </thead>
            <tbody>
              <tr class="app-single-agent" *ngFor="let index of violationsKeys;let indexOfelement=index;">
                <td scope="row">{{indexOfelement+1}}</td>
                <td>{{index}}</td>
                <td>{{violationCount[index].Count}}</td>
                <td>{{violationCount[index].ActionSummary}}</td>
              </tr>
            </tbody>
          </table>

        </ng-container>

      </div>
    </div>
  </div>